import service from '../config/axios.config';
import { addAlert } from './alerts.action';

export const FETCH_ACCOUNT_INFO = 'cx-ray/EMPLOYEE/ACCOUNT_INFO/FETCH';

const createFetchAction = payload => ({
  type: FETCH_ACCOUNT_INFO,
  payload
});

export const fetchAccountInfo = () => async dispatch => {
  try {
    const url = `/accountInfo`;
    const { data = {} } = await service.get(url) ?? {};

    dispatch(createFetchAction(data));
  } catch (error) {
    dispatch(addAlert({ message: error.message, severity: 'error' }));
  }
};
